import { defineMessage, MessageDescriptor } from 'react-intl';
import { CategoryType } from './categories';

export type UseCase = BaseUseCase & {
  categories: CategoryType[];
  linkedCategories: CategoryType[];
};

export type BaseUseCase = {
  id: string;
  title: MessageDescriptor;
  description?: MessageDescriptor;
};

const triggerProductSync = {
  title: defineMessage<MessageDescriptor>({
    id: 'use-case-trigger-product-sync',
    defaultMessage: 'Trigger product sync from Shopify to Teamleader',
  }),
  id: 'trigger-product-sync',
  categories: ['online-store'],
  linkedCategories: ['crm'],
} as UseCase;

const triggerAllOnlineStoreToCrmSyncFeatures = {
  title: defineMessage<MessageDescriptor>({
    id: 'use-case-trigger-all-online-store-to-crm-sync-features',
    defaultMessage: 'I want to sync all my Shopify activity to Teamleader',
  }),
  id: 'trigger-all-online-store-to-crm-sync-features',
  categories: ['online-store'],
  linkedCategories: ['crm'],
} as UseCase;

const triggerOnlineSalesCreateDealAndQuotation = {
  title: defineMessage<MessageDescriptor>({
    id: 'use-case-trigger-online-sales-create-deal-and-quotation',
    defaultMessage: 'Trigger the creation of quotations in Teamleader',
  }),
  id: 'trigger-online-sales-create-deal-and-quotation',
  categories: ['online-store'],
  linkedCategories: ['crm'],
} as UseCase;

const triggerOnlineSalesCreateDeal = {
  title: defineMessage<MessageDescriptor>({
    id: 'use-case-trigger-online-sales-create-deal',
    defaultMessage: 'Auto create a deal in Teamleader, based on Shopify online sales',
  }),
  id: 'trigger-online-sales-create-deal',
  categories: ['online-store'],
  linkedCategories: ['crm'],
} as UseCase;

const triggerOnlineSalesCreateInvoice = {
  title: defineMessage<MessageDescriptor>({
    id: 'use-case-trigger-online-sales-create-invoice',
    defaultMessage: 'Shopify sales trigger invoices in Teamleader',
  }),
  id: 'trigger-online-sales-create-invoice',
  categories: ['online-store'],
  linkedCategories: ['crm'],
} as UseCase;

const syncContacts = {
  title: defineMessage<MessageDescriptor>({
    id: 'sync-contacts',
    defaultMessage: 'Shopify contacts sync to Teamleader',
  }),
  id: 'sync-contacts',
  categories: ['crm', 'pms', 'online-store'],
  linkedCategories: ['crm', 'pms', 'online-store'],
} as UseCase;

const usecases: UseCase[] = [
  triggerOnlineSalesCreateDeal,
  triggerOnlineSalesCreateDealAndQuotation,
  triggerOnlineSalesCreateInvoice,
  syncContacts,
  triggerProductSync,
  triggerAllOnlineStoreToCrmSyncFeatures,
];

export default usecases;
